import React, { useEffect, useState } from 'react';
import { useSensory } from '../context/SensoryContext';

// Types and deletes each phrase in turn. Screen readers get the first phrase only.
const Typewriter = ({ phrases, typeSpeed = 55, deleteSpeed = 30, pause = 1800 }) => {
  const { reducedMotion } = useSensory();
  const [index, setIndex] = useState(0);
  const [text, setText] = useState('');
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (reducedMotion) return undefined;
    const phrase = phrases[index];
    let delay = deleting ? deleteSpeed : typeSpeed;

    if (!deleting && text === phrase) {
      delay = pause;
    } else if (deleting && text === '') {
      delay = 300;
    }

    const timer = setTimeout(() => {
      if (!deleting && text === phrase) {
        setDeleting(true);
      } else if (deleting && text === '') {
        setDeleting(false);
        setIndex((i) => (i + 1) % phrases.length);
      } else {
        setText(deleting ? phrase.slice(0, text.length - 1) : phrase.slice(0, text.length + 1));
      }
    }, delay);
    return () => clearTimeout(timer);
  }, [text, deleting, index, phrases, typeSpeed, deleteSpeed, pause, reducedMotion]);

  return (
    <span className="typewriter">
      <span className="sr-only">{phrases[0]}</span>
      <span aria-hidden="true">
        {reducedMotion ? phrases[0] : text}
        <span className="typewriter-caret" />
      </span>
    </span>
  );
};

export default Typewriter;
